import { call, takeLatest } from 'redux-saga/effects';
import * as api from '@api/sponsor';
import {
  SponsorOverviewFetchAction,
  SponsorOverviewSummaryFetchAction,
} from './sponsorOverview.types';
import { actions } from './sponsorOverview.slice';
import { Resp, dispatch } from '../helpers';

export function* sponsorOverviewFetchWorker({
  payload: { clinicalTrialId, filters },
}: SponsorOverviewFetchAction) {
  try {
    const baseParams = {
      page: filters?.page ? filters.page - 1 : 0,
      size: filters?.size ?? 10,
    };

    const params: SponsorOverviewFetchAction['payload']['filters'] =
      Object.entries(filters).reduce(
        (acc, [key, value]) => {
          if (value) {
            if (value === 'UNSCHEDULED') {
              return {
                ...acc,
                visitDefinitionId: null,
                unscheduled: true,
              };
            }
            return {
              ...acc,
              [key]: value,
            };
          }
          return acc;
        },
        { ...baseParams }
      );
    const response: Resp<typeof api.fetchSponsorOverview> = yield call(
      api.fetchSponsorOverview,
      clinicalTrialId,
      'OVERVIEW',
      params
    );
    yield dispatch(actions.fetchSponsorOverviewSuccess(response.data));
  } catch (e) {
    yield dispatch(actions.fetchSponsorOverviewError(e as Error));
  }
}

export function* sponsorOverviewSummaryFetchWorker({
  payload: { clinicalTrialId },
}: SponsorOverviewSummaryFetchAction) {
  try {
    const response: Resp<typeof api.fetchSponsorOverviewSummary> = yield call(
      api.fetchSponsorOverviewSummary,
      clinicalTrialId,
      'UPLOAD_SUMMARY'
    );
    yield dispatch(actions.fetchSponsorOverviewSummarySuccess(response.data));
  } catch (e) {
    yield dispatch(actions.fetchSponsorOverviewSummaryError(e as Error));
  }
}

export function* sponsorOverviewSaga() {
  yield takeLatest(
    actions.fetchSponsorOverview.type,
    sponsorOverviewFetchWorker
  );
  yield takeLatest(
    actions.fetchSponsorOverviewSummaryRequest.type,
    sponsorOverviewSummaryFetchWorker
  );
}
